/* oxlint-disable react/jsx-props-no-spreading -- props are intentionally forwarded by this adapter */
import { useField } from 'remix-validated-form'
import { FormInputWrapperProps } from 'app/components/form/FormInputWrapper'

type FormInputProps = {
  name: string
  value?: string | string[] | undefined
} & FormInputWrapperProps<HTMLInputElement>

export default function FormHiddenInput({ name, value, ...props }: FormInputProps) {
  const { getInputProps } = useField(name)
  const inputProps = getInputProps({ ...props, type: `hidden` })

  if (value === undefined) return <input {...inputProps} />

  const { defaultValue: _defaultValue, ...controlledInputProps } = inputProps

  return <input {...controlledInputProps} value={value} />
}
